export default __webpack_public_path__ + "static/media/unauthorized.819ea9ba.png";